import React, { useEffect, useState, useContext } from 'react';
import styles from './Settings.module.css';
import { getStoresFromDatabase } from "../../hooks/Store";
import { createProductStatus, findProductStatusByStoreId } from "../../hooks/Settings";
import { StoresContext } from '../../context/StoresContext';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Import = () => {
    const { setStore } = useContext(StoresContext);
    const [stores, setStores] = useState([]);
    const [selectedStoreId, setSelectedStoreId] = useState(null);

    const [greenDays, setGreenDays] = useState(0);
    const [yellowDays, setYellowDays] = useState(0);
    const [redDays, setRedDays] = useState(0);

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try {
            const storeData = await getStoresFromDatabase();
            if (storeData) {
                setStores(storeData.data.stores);
            }
        } catch (err) {
            console.error("Error to search stores:", err);
        }
    };

    useEffect(() => {
        fetchProductStatusByStoreId();
    }, [selectedStoreId]);
    
    const fetchProductStatusByStoreId = async () => {
        if (!selectedStoreId) {
            return;
        }
    
        try {
            const productStatusData = await findProductStatusByStoreId( selectedStoreId );
            if (productStatusData && productStatusData.data) {

                const items = productStatusData.data;
                const greenItem = items.find(item => item.color === "green");
                const yellowItem = items.find(item => item.color === "yellow");
                const redItem = items.find(item => item.color === "red");
    
                setGreenDays(greenItem ? greenItem.daysThreshold : 0);
                setYellowDays(yellowItem ? yellowItem.daysThreshold : 0);
                setRedDays(redItem ? redItem.daysThreshold : 0);
            }
        } catch (err) {
            console.error("Error fetching product status:", err);
            toast.error("Erro ao buscar status dos produtos.");
        }
    };

    const handleStoreChange = (event) => {
        const storeId = event.target.value;
        setSelectedStoreId(storeId);

        const selectedStore = stores.find(store => store.id === Number(storeId));
        setStore(selectedStore);
    };

    const handleSave = async () => {
        if (!selectedStoreId) {
            toast.error("Por favor, selecione uma loja!");
            return;
        }

        const productStatusData = {
            storeId: Number( selectedStoreId ),
            items: [
                { color: "green", daysThreshold: greenDays },
                { color: "yellow", daysThreshold: yellowDays },
                { color: "red", daysThreshold: redDays }
            ]
        };

        try {
            await createProductStatus( productStatusData );
            toast.success("Status dos produtos salvo com sucesso!");
        } catch (err) {
            console.error("Error saving product status:", err);
            toast.error("Erro ao salvar os status dos produtos.");
        }
    };

    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.stores}>
                <select className={styles.storeDropdown} onChange={handleStoreChange}>
                    <option value="" disabled selected>Selecione uma loja</option>
                    {stores.map((store) => (
                        <option key={store.id} value={store.id}>{store.name}</option>
                    ))}
                </select>
            </div>

            <div className={styles.productStatusContainer}>
                <h4 className={styles.header}>Status dos produtos para vencer</h4>
                <div className={styles.productStatus}>
                    <div className={styles.statusRow}>
                        <div className={styles.colorCircle} style={{ backgroundColor: 'green' }}></div>
                        <span className={styles.statusLabel}>Verde</span>
                        <input
                            type="number"
                            className={styles.inputDays}
                            placeholder="0"
                            min="0"
                            value={greenDays}
                            onChange={(e) => setGreenDays(Number(e.target.value))}
                        />
                    </div>

                    <div className={styles.statusRow}>
                        <div className={styles.colorCircle} style={{ backgroundColor: 'yellow' }}></div>
                        <span className={styles.statusLabel}>Amarelo</span>
                        <input
                            type="number"
                            className={styles.inputDays}
                            placeholder="0"
                            min="0"
                            value={yellowDays}
                            onChange={(e) => setYellowDays(Number(e.target.value))}
                        />
                    </div>

                    <div className={styles.statusRow}>
                        <div className={styles.colorCircle} style={{ backgroundColor: 'red' }}></div>
                        <span className={styles.statusLabel}>Vermelho</span>
                        <input
                            type="number"
                            className={styles.inputDays}
                            placeholder="0"
                            min="0"
                            value={redDays}
                            onChange={(e) => setRedDays(Number(e.target.value))}
                        />
                    </div>
                </div>

                <div className={styles.actionButtons}>
                    <button className={styles.cancelButton}>Cancelar</button>
                    <button className={styles.saveButton} onClick={ handleSave }>Salvar</button>
                </div>
            </div>
        </div>
    );
};

export default Import;
